import { CSelectItem } from '../../../types';

export const items: CSelectItem[] = [
  { name: 'Banana', value: 'banana' },
  { name: 'Pineapple', value: 'pineapple' },
  { name: 'Apple', value: 'apple' },
  { name: 'Orange', value: 'orange' },
  { name: 'Pear', value: 'pear' },
  { name: 'Lemon', value: 'lemon' },
  { name: 'Coconut', value: 'coconut' },
];
